import { resolveApiUrl } from "~/utils/url/urlResolver";
import { getCsrfValue } from "~/api/ApiHelper";

export interface SubmitCustomerRegistrationDTO {
  companyName: string;
  addressLine1: string;
  postalCode: string;
  city: string;
  country: string;
  purchaseAmt: number;
  currency: string;
  sector: string;
  taxId?: string;
  fullName: string;
  jobTitle: string;
  email: string;
  telephoneNumber?: string;
  whySchaeffler: string;
  yourCurrentSupplier: string;
  consent: boolean;
}

const apiUrl = resolveApiUrl("/become-schaeffler-customer/submit");

export const apiSubmitCustomerRegistration = (data: SubmitCustomerRegistrationDTO): Promise<Response> => {
  return fetch(apiUrl, {
    body: JSON.stringify(data),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
};
